<template>
  <BaseButton
    color="inverse"
    class="flex items-center justify-center px-0 pr-2 py-1.5 my-1"
    @click="$emit('click')"
  >
    <ArrowLeft class="mr-1 relative w-5 h-5" />

    <div class="flex items-center">
      {{ text || 'Back' }}
    </div>
  </BaseButton>
</template>

<script>
import ArrowLeft from '@tagvenue/icons/24/line/arrows/chevron-left.svg';

import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'BackButton',
  emits: ['click'],
  components: { BaseButton, ArrowLeft },
  props: {
    text: {
      type: String,
      default: 'Back',
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
